









import {
  defineComponent,
  computed,
} from '@nuxtjs/composition-api';
import { Logger, usePageStore } from '@wemade-vsf/core';
import type { RoutableInterface } from '@wemade-vsf/magento-api';

// import CATEGORY from 'pages/catalog/Category.vue';
// import CMS_PAGE from 'pages/theme/Cms.vue';
// import PRODUCT from 'pages/catalog/Product.vue';

export default defineComponent({
  name: 'PageResolver',
  components: {
    CATEGORY: () => import('pages/catalog/Category.vue'),
    CMS_PAGE: () => import('pages/theme/Cms.vue'),
    PRODUCT: () => import('pages/catalog/Product.vue'),
  },
  async middleware (context) {
    const pageStore = usePageStore();
    const { path } = context.route;

    const localeStart = `/${context.i18n.locale}/`
    let clearUrl = path.replace(/[a-z]+\/[cp|]\//gi, '')
    if (clearUrl.startsWith(localeStart)) {
      clearUrl = clearUrl.substring(localeStart.length - 1);
    }

    Logger.debug('middleware/url-resolver', clearUrl);

    const { data, errors } = await context.app.$vsf.$magento.api.route(clearUrl);

    Logger.debug('middleware/url-resolver/result', { data, errors });

    const results: RoutableInterface | null = data?.route ?? null;

    if (!results || errors?.length) context.error({ statusCode: 404 });

    pageStore.$patch((state) => {
      state.routeData = results;
    });
  },
  setup() {
    const { routeData } = usePageStore();

    const type = computed(() => routeData?.type);

    return {
      type,
    };
  },
});
